import { createFileRoute, Outlet } from "@tanstack/react-router";
import { PageContainer, PageHeader } from "@/components/layout/page";
import { PageTabs } from "@/components/nav/tabbed-page";

export const Route = createFileRoute("/_app/endpoints")({
  component: EndpointsLayout,
});

function EndpointsLayout() {
  return (
    <PageContainer>
      <PageHeader
        title="Endpoints"
        description="External data access — ingest, query, and API keys."
      />
      <PageTabs
        tabs={[
          { label: "Ingest", to: "/endpoints/ingest" },
          { label: "Query", to: "/endpoints/query" },
          { label: "API Keys", to: "/endpoints/keys" },
        ]}
      />
      <Outlet />
    </PageContainer>
  );
}
